















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { SelectionType, TileType } from '@/data/enums'
import NavigationButtons from './ui/NavigationButtons.vue'
import SelectionGrid from './SelectionGrid.vue'

@Component({
  components: {
    NavigationButtons,
    SelectionGrid
  }
})
export default class ProfileStep extends Vue {
  @Prop({ default: -1 }) public currentStep?: number
  @Prop() public subtitle?: string
  @Prop() public tileType!: TileType
  @Prop() public title?: string
  @Prop() public type!: SelectionType
  @Prop() public prev!: string
  @Prop() public next!: string
  @Prop() public extra!: string
}
